// For more information: https://www.chartjs.org/docs/latest/
import {
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    Tooltip
} from 'chart.js';

Chart.register(
    BarElement,
    BarController,
    CategoryScale,
    LinearScale,
    Legend,
    Tooltip
);

export default class ChartJS {

    static init() {
        this.initResultGraph();
    }

    static initResultGraph() {
        const labels = [
            'Empreinte carbone', 'App. Couche Ozone', 'Acidification Air', 'Eutro. Eaux Douces', 'Eutro. Marine',
            'Epuisement Eau', 'Ressources Foss.', 'Ressources Minér.'
        ];
        const data = {
            labels: labels,
            datasets: [
                {
                    maxBarThickness: 25,
                    label: 'Lait',
                    data: [],
                    backgroundColor: '#00c0c7'
                },
                {
                    maxBarThickness: 25,
                    label: 'Ingrédients',
                    data: [],
                    backgroundColor: '#5144d3'
                },
                {
                    maxBarThickness: 25,
                    label: 'Transformation',
                    data: [],
                    backgroundColor: '#e8871a'
                },
                {
                    maxBarThickness: 25,
                    label: 'Emballages',
                    data: [],
                    backgroundColor: '#da3490'
                },
                {
                    maxBarThickness: 25,
                    label: 'Distribution',
                    data: [],
                    backgroundColor: '#9089fa'
                }
            ]
        };
        new Chart('detailsChart', {
            type: 'bar',
            data: data,
            options: {
                spanGaps: false,
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false
                        },
                        ticks: {
                            maxRotation: 90,
                            minRotation: 90

                        }
                    },
                    y: {
                        stacked: true,
                        min: 0,
                        max: 100
                    }
                },
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            usePointStyle: true
                        }
                    }
                }
            }
        });
    }

    static getCurrentChartInstance() {
        return Chart.instances[0];
    }

}
